// The customer fields a new appointment carries so the coach sees who booked
// it (namat#36 P1-9). Kept byte-identical in namat (web) and namat-mobile.
//
// Profiles store names as firstNameAr/lastNameAr and firstNameEn/lastNameEn;
// the older firstName/lastName pair is often blank, so it is only a fallback
// for the English name. Each language falls back to the other so a profile
// with one script still produces a name. customerName follows the existing
// convention elsewhere (NextAppointmentDialog): the English name.

export interface AppointmentCustomerSource {
  firstName?: string | null;
  lastName?: string | null;
  firstNameAr?: string | null;
  lastNameAr?: string | null;
  firstNameEn?: string | null;
  lastNameEn?: string | null;
  phone?: string | null;
}

export interface AppointmentCustomerFields {
  customerName: string;
  customerNameAr: string;
  customerNameEn: string;
  customerPhone: string;
}

const join = (first?: string | null, last?: string | null): string =>
  `${(first || '').trim()} ${(last || '').trim()}`.trim();

export function appointmentCustomerFields(
  customer: AppointmentCustomerSource | null | undefined
): AppointmentCustomerFields {
  if (!customer) {
    return { customerName: '', customerNameAr: '', customerNameEn: '', customerPhone: '' };
  }
  const ar = join(customer.firstNameAr, customer.lastNameAr);
  const en =
    join(customer.firstNameEn, customer.lastNameEn) ||
    join(customer.firstName, customer.lastName);
  const customerNameEn = en || ar;
  const customerNameAr = ar || en;
  return {
    customerName: customerNameEn,
    customerNameAr,
    customerNameEn,
    customerPhone: (customer.phone || '').trim(),
  };
}
